import refreshIcon from 'shared/assets/retry.svg'
import Style from './style'

const RefreshButton = ({onClick, loading = false}) => {
	return (
		<Style.Container onClick={onClick} loading={loading}>
			<img src={refreshIcon} alt='refresh' />
		</Style.Container>
	)
}

export default RefreshButton
